import _ from 'lodash';

function convertNodeToPhrase(node) {
    return {
        id: node.id,
        parentId: node.name ? '' : node.parentId,
        testCaseId: node.testCaseId,
        request: _.isObject(node.request) ? node.request : { text: node.request },
        response: _.isObject(node.response) ? JSON.stringify(node.response) : node.response,
        meta: _.isObject(node.meta) ?
            JSON.stringify(node.meta) :
            node.meta,
        visualProperties: _.isObject(node.visualProperties) ?
            JSON.stringify(node.visualProperties) :
            node.visualProperties
    };
}

export default convertNodeToPhrase;
